import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://jalworkspace.tech";
export const API = `${BACKEND_URL.replace(/\/$/, '')}/api`;

export const api = axios.create({
  baseURL: API,
  // No axios timeout — WhatsApp send / wake can take longer than any fixed client limit.
  // Browser / nginx still apply their own limits if configured.
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.endsWith("/auth/login")) {
      localStorage.removeItem("lp_token");
      localStorage.removeItem("lp_user");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);
